import { Checkbox } from "@progress/kendo-react-inputs";

export const TrackLastUpdateProperty = {
  propertyName: "TrackLastUpdate",
  propertyDisplay: "Track Last Update?",
  propertyType: "boolean",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
